import { Component } from "react";
import { NSARouterMakerResult } from "namirasoft-account-react";
import { StorageLayout } from "../StorageLayout";
import { StorageEntities } from "../StorageEntities";
import { StorageRouterProps } from "../StorageRouterProps";

export interface AssignmentListPageProps extends NSARouterMakerResult, StorageRouterProps { }

class AssignmentListPage extends Component<AssignmentListPageProps>
{
    override render()
    {
        return (
            <StorageLayout
                {...this.props}
                pages={{
                    entity: StorageEntities.assignment(this.props),
                    list: {}
                }}
            >
                <></>
            </StorageLayout>
        );
    }
}

export default AssignmentListPage;